// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1nScZ","header":"ReportDetails_header__12jEy","title":"ReportDetails_title__3DuX7","left":"ReportDetails_left__3z01Z"};